import React, { useEffect, useState } from "react";
import { Redirect } from "react-router-dom";
import queryString from "query-string";
import { hydrateRoute, toName, format, parseFilter, stringifyFilter } from "../../utils";
import { useGlobalValue } from "../../state/GlobalProvider";
import { SovosTab, SovosTabs } from "mosaic-react";
const getCurrentTab = (data, routeKey, lastPart) => {
  return (data || []).find(route => `${route[routeKey]}` === lastPart);
};
const buildRouteWithoutTab = (currentTab, hydrated, routeKey) => {
  return currentTab ? hydrated.replace(new RegExp(`${currentTab[routeKey]}/?$`, "ig"), "") : hydrated;
};
const filterTabsByCount = (data, preserveEmptyTabs) => {
  return preserveEmptyTabs ? data || [] : (data || []).filter(elem => elem.count !== 0);
};
const buildTabs = (tabsToShow, withoutTabRoute, routeKey, urlFilters, labelKey, showCount, paths, concatTab, lastPart, i18n) => {
  return tabsToShow.map((route, index) => {
    const tabToUse = concatTab && lastPart !== route[routeKey] ? `${lastPart}/${route[routeKey]}` : `${route[routeKey]}`;
    const path = `${withoutTabRoute}${withoutTabRoute.match(/\/$/) ? "" : "/"}${route[routeKey] === "/" ? "" : tabToUse}${urlFilters.length ? `?filter=${urlFilters}&resetFilters=${Date.now()}` : ""}`;
    paths.push(path);
    return /*#__PURE__*/React.createElement(SovosTab, {
      key: index,
      value: path,
      label: `${i18n`${toName(route[labelKey])}`}${showCount ? ` (${format(route.count, "normal", null)})` : null}`
    });
  });
};
const DataGridTabs = props => {
  const {
    data,
    labelKey,
    routeKey,
    basePath,
    redirectEnabler,
    showCount,
    preserveEmptyTabs,
    preserveFilters,
    concatTab
  } = props;
  const {
    i18n,
    params: matchParams,
    location,
    history
  } = useGlobalValue();
  const params = {
    ...matchParams,
    ...queryString.parse(location.search)
  };
  const hydrated = hydrateRoute(basePath, {
    ...params
  });
  const [selectedTab, setSelectedTab] = useState(null);
  const [sovosTabs, setSovosTabs] = useState([]);
  const [currentTab, setCurrentTab] = useState(true);
  useEffect(() => {
    if (data) {
      const lastPart = location.pathname.match(/\/$/) ? location.pathname.split("/").slice(-2)[0] : location.pathname.split("/").slice(-1)[0];
      const tab = getCurrentTab(data, routeKey, lastPart);
      setCurrentTab(tab);
      const routeWithoutTab = buildRouteWithoutTab(tab, hydrated, routeKey);
      const tabsToShow = filterTabsByCount(data, preserveEmptyTabs);
      const paths = [];
      const tabs = buildTabs(tabsToShow, routeWithoutTab, routeKey, urlFilters, labelKey, showCount, paths, concatTab, lastPart, i18n);
      setSovosTabs(tabs);
      setSelectedTab(paths.find(path => location.pathname === path));
    }
  }, [data]);
  let urlFilters = "";
  if (preserveFilters && preserveFilters.length) {
    const filtersArray = parseFilter(params.filter);
    const filtersToUse = (filtersArray || []).filter(({
      column
    }) => preserveFilters.includes(column));
    urlFilters = filtersToUse && filtersToUse.length && Array.isArray(filtersToUse) ? stringifyFilter(filtersToUse) : "";
  }
  if (!data || !labelKey || !routeKey) {
    return null;
  }
  if (redirectEnabler && !currentTab && (data || []).length && location.pathname.split("/").pop() !== `${data[0][routeKey] || ""}`) {
    const to = `${hydrated}${hydrated.match(/\/$/) ? "" : "/"}${data[0][routeKey] === "/" ? "" : data[0][routeKey]}`;
    if (to !== location.pathname) {
      return /*#__PURE__*/React.createElement(Redirect, {
        to: to,
        replace: true
      });
    }
  }
  return /*#__PURE__*/React.createElement(SovosTabs, {
    onChange: (_, value) => {
      setSelectedTab(value);
      history.push({
        pathname: value
      });
    },
    value: selectedTab
  }, sovosTabs);
};
export default DataGridTabs;